import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllActivityLog = createAsyncThunk('activity/all', async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`activity-log/get-activity-log/${id}`)
      return response
    } catch (error) {
      return rejectWithValue(error)
    }
  })
const initialState = {
  isLoading: false,
  allLogData: [],
  error: null
}

const LogSlice = createSlice({
  name: 'Log',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllActivityLog.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllActivityLog.fulfilled, (state, action) => {
        state.isLoading = false
        state.allLogData = action.payload?.data?.data
      })
      .addCase(getAllActivityLog.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default LogSlice.reducer
